import { useNavigate } from 'react-router-dom';
import SmallLogoDark from '../../assets/images/small-logo-drak.svg';
import launch10Logo from '../../assets/images/Logo_Launch10.svg';
import scrubblyLogo from '../../assets/images/scrubblyLogo.png';
import { useDispatch, useSelector } from 'react-redux';
import { setIsConsentSelected } from '../../redux/slice/userAgreementSlice';
import { GENERATE_TOKEN } from '../../config/endpoint';
import loaderService from '../../service/loaderService';
import { axiosInstance } from '../../config/axiosConfig';
const AllConsents = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userAgreement = useSelector((state) => state.userAgreement)
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const cards = [
        // { id: 1, title: 'Coming Soon', enabled: false },
        // { id: 2, title: 'Coming Soon', enabled: false },
        {
            id: 1,
            title: 'BrainyAgent Analytics',
            icon: SmallLogoDark,
            enabled: false,
            redirectTo: '/dashboard/consent'
        },
        { id: 2, icon: scrubblyLogo, title: 'Savviq Central', enabled: false, otherAppURL: "http://savviq.brainyagent.ai/#/verify?token=" },
        { id: 3, icon: launch10Logo, title: 'Launch10', enabled: true, otherAppURL: "http://brainyaudit.brainyagent.ai/#/verify?token=" },
        { id: 4, title: 'Coming Soon', enabled: false },
        { id: 5, title: 'Coming Soon', enabled: false },
        { id: 6, title: 'Coming Soon', enabled: false }
    ];

    const handleCardClick = (card) => {
        if (card.enabled) {
            if (card.redirectTo) {
                if (userAgreement?.isAgreed) {
                    navigate('/dashboard/all-set');
                } else {
                    dispatch(setIsConsentSelected(true))
                    navigate(card.redirectTo);
                }
            }
            if (card.otherAppURL) {
                generateToken(card.otherAppURL)

            }

        }
    };

    const generateToken = async (redirectTo) => {
        //loaderService.show()
        debugger
        const res = await axiosInstance.get(GENERATE_TOKEN, {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') },
        });
        const token = res?.token;
        if (!token) throw new Error('Token missing in response');

        const userId = userInfo?.UserId ?? '';
        const url = `${redirectTo}${encodeURIComponent(token)}&id=${encodeURIComponent(userId)}`;

        // open without navigating away from current SPA
        window.open(url, '_blank', 'noopener');
        // await axiosInstance.get(GENERATE_TOKEN)
        //     .then((res) => {
        //         debugger;
        //         //window.open(`${redirectTo}${res.token}&id=${userInfo.UserId}`, '_blank');
        //     })
        //     .catch((err) => {
        //         debugger;
        //     }).finally(() => {
        //         loaderService.hide()
        //     })
    }

    return (
        <>
            <p className='font-18-white'>Click on any of our AI tools to begin!</p>

            <div className='row m-0 newUserCards w-100 g-3'>
                {cards.map((card) => (
                    <div key={card.id} className='col-3'>
                        <div
                            className={`newUserCard ${!card.enabled ? 'disabled' : ''}`}
                            onClick={() => handleCardClick(card)}
                        >
                            {card.enabled ? (
                                <>
                                    {card.icon && <img src={card.icon} alt={card.title} height={56} width={56} />}
                                    <p className='title'>{card.title}</p>
                                </>
                            ) : (
                                <>
                                    {card.icon && <img src={card.icon} alt={card.title} height={56} width={56} />}
                                    <p className='title-disabled'>{card.title}</p>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default AllConsents
